<template>
  <q-list v-if="reminders.length > 0" dense>
    <q-item-wrapper
      v-for="(reminder, key) in reminders"
      :key="key"
      :caption="minutesToStr(reminder.reminder_offset, nullLabel, zeroLabel, withSuffixLabel ? getOffsetStr(reminder.reminder_offset) : null)"
      :icon="reminder.type ? getFieldValue(reminder.type, 'icon') : 'mdi-bell-badge-outline'"
      :color="reminder.type ? getFieldValue(reminder.type, 'color') : undefined"
      :icon-right="reminder.has_sent ? 'mdi-check' : undefined"
      class="invisible-item no-padding"
    />
  </q-list>
</template>

<script>
import communicationMixin from 'components/partials/communications/communicationMixin'

/**
 * ReminderList allows you to print a list of reminders as a set of strings
 */
export default {
  mixins: [communicationMixin],
  props: {
    // Array of reminder objects
    reminders: {
      type: Array,
      required: true
    },
    // Label for minutes being unset (null)
    nullLabel: {
      type: String,
      default: 'None'
    },
    // Label for minutes set as 0
    zeroLabel: {
      type: String,
      default: 'At time of appointment'
    },
    // Display the suffix label after the specified formatted time (before, after)
    withSuffixLabel: {
      type: Boolean,
      default: true
    },
    // [null (any), 'before' (negative values), 'after' (positive values)] : limit how offset options can be chosen
    limitOffset: {
      type: String,
      default: 'before'
    },
    beforeStr: {
      type: String,
      default: 'before'
    },
    afterStr: {
      type: String,
      default: 'after'
    }
  },
  methods: {
    getOffsetStr (offset) {
      if (!offset && this.limitOffset === 'before') {
        return this.beforeStr
      }
      return (!offset || offset >= 0) ? this.afterStr : this.beforeStr
    }
  }
}
</script>
